import angular from 'angular';
import _ from 'lodash';

const PROTOCOL = location.protocol || 'http:';
const API_URL = PROTOCOL + '//netfree.link/api/campin-netspark-1';

let self;

class donationsService {
  constructor ($http) {
    self = this;
    self.$http = $http;
    self.donations = [];
    self.commitments = [];
  }

  getDonations () {
    return self.$http({ url: API_URL })
      .then((result) => {
        self.donations = _.get(result, 'data.list') || [];
        self.commitments = _.get(result, 'data.kevaList') || [];
        console.log(self);

        self.total = 0;
        self.totalCommitmens = 0;
        self.totalDonors = self.donations.length + self.commitments.length;
        let totalByDates = {};

        let date;
        self.donations.forEach((item) => {
          item.amount = Number(item.amount);
          self.total += item.amount;

          // calc total by days
          let currentDate = item.time.split(' ')[0];
          if (date !== currentDate) {
            totalByDates[currentDate] = { date: item.timeISO, total: 0 };
          }
          totalByDates[currentDate].total += item.amount;
          date = currentDate;
        });

        self.commitments.forEach((item) => {
          if (item.countLeft === null) {
            item.unlimited = true;
          }

          item.amount = Number(item.amount);

          item.totalLeftAmount = item.amount * Number(item.countLeft === null ? 1 : item.countLeft);
          self.totalCommitmens += item.totalLeftAmount;
        });

        self.total += self.totalCommitmens;

        self.totalByDates = Object.values(totalByDates);

        return {
          donations: self.donations,
          commitments: self.commitments
        };
      });
  }
}

donationsService.$inject = ['$http'];

let donationsServiceModule = angular.module('donationsService', [])
  .service('donationsService', donationsService)
  .name;

export default donationsServiceModule;



// WEBPACK FOOTER //
// ./client/app/services/donations.service.js